import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

export default function Info() {
  const [isVisible, setIsVisible] = useState(null);

  const socials = [
    {
      social: "Twitter / X",
      link: "https://twitter.com/saboor_x",
    },
    {
      social: "Github",
      link: "https://github.com/sabooralt",
    },
    {
      social: "Linkedin",
      link: "https://linkedin.com/in/saboor7",
    },
  ];

  return (
    <div className="col-lg-6 col-md-6 col-sm-12 contact-info-box position-relative">
      <h1
        className="form-heading"
        style={{
          letterSpacing: "2px",
          whiteSpace: "nowrap",
        }}
      >
        Let's Talk
      </h1>

      <p className="mt-4">
        Connect with me to bring your ideas to life. Reach out through the form
        and let's start crafting something amazing together!
      </p>
      <div className="d-flex flex-row mail_phone">
        <div>
          <span className="uppercase">Mail:</span>
          <p>
            {" "}
            <a
              href="mailto:abdulsaboormillwala123@gmail.com"
              className="chonkyunderline "
            >
              saboordevelops@gmail.com
            </a>
          </p>
        </div>
        <div>
          <span className="uppercase">Phone:</span>
          <p>+92 3481807502</p>
        </div>
      </div>

      <div className="d-flex row justify-content-start align-items-center position-relative bottom-0 w-100">
        <div className="d-flex flex-column col-6">
          <p className="cursor-pointer">Sindh,Karachi</p>

          <p>Pakistan</p>
        </div>

        <div className="text-white d-flex flex-column justify-content-center align-items-end col-6 contact">
          {socials.map((social, index) => (
            <motion.a
              target="_blank"
              rel="noreferrer"
              href={social.link}
              key={index}
              whileHover={{ scale: 1.1, paddingLeft: 20 }}
              transition={{ type: "spring", stiffness: 100, damping: 5 }}
              className=" d-inline-block w-fit text-white pb-3"
              onHoverStart={() => setIsVisible(index)}
              onHoverEnd={() => setIsVisible(null)}
            >
              <AnimatePresence mode="wait">
                {isVisible === index && (
                  <motion.div
                    className="w-fit d-inline-block"
                    initial={{
                      x: -10,
                      rotate: 45,
                      opacity: 0,
                    }}
                    animate={{
                      opacity: 1,
                      rotate: 0,
                      x: 0,
                      type: "spring",
                      stiffness: 400,
                      damping: 10,
                    }}
                    exit={{ opacity: 0, rotate: 45 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className="bi bi-arrow-up-right"></i>
                  </motion.div>
                )}
              </AnimatePresence>

              <span>{social.social}</span>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
}
